import { render, staticRenderFns } from "./ProtestTaxPaymentsList.vue?vue&type=template&id=6998d99e&"
import script from "./ProtestTaxPaymentsList.vue?vue&type=script&lang=js&"
export * from "./ProtestTaxPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports